import axios from 'axios'
import store from '@/store'
import router from '@/router'
import app from '@/main'

const instance = axios.create({
  baseURL: '/api'
})

if (localStorage.getItem('access_token') || '') {
  instance.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('access_token') || ''
}

instance.interceptors.request.use(config => {
  // 사용자 정보(user_seq, user_type)를 넣어준다.
  if (config.method !== 'get' && config.data !== undefined) {
    config.data.user_seq = parseInt(store.getters.user_seq, 10)
    config.data.ss_user_type = store.getters.user_type
  }
  app.$Progress.start()
  return config
})

instance.interceptors.response.use(response => {
  app.$Progress.finish()
  // Token 에러일 경우에는 로그인 페이지로 이동한다.
  if (response.data.status === -99) {
    const userType = store.getters.user_type ? store.getters.user_type : 'S'
    store.dispatch('AUTH_LOGOUT').then(() => {
      router.push({name: 'LOGIN_' + userType})
    })
    return false
  } else {
    return response
  }
}, error => {
  console.error('axios error : ', error)
  if (app.$message) {
    app.$message.error('일시적인 시스템 장애입니다. 잠시 후 다시 시도해주세요.')
  }
  app.$Progress.fail()
  return Promise.reject(error)
})

export default instance



// WEBPACK FOOTER //
// ./src/modules/api-axios.js